import { render, staticRenderFns } from "./gjw.vue?vue&type=template&id=6f85deaa&scoped=true&"
var script = {}
import style0 from "./gjw.vue?vue&type=style&index=0&id=6f85deaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85deaa",
  null
  
)

export default component.exports